export function Spinner({ className = '' }: { className?: string }) {
  return (
    <div className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${className || 'h-4 w-4 text-primary'}`} />
  );
}
